import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

const routes: Routes = [
  {
    path: 'sv',
    loadChildren: () => import('./response-video/response-video.module')
      .then(m => m.ResponseVideoModule)
  },
  {
    path: 'st',
    loadChildren: () => import('./response-tradicional/response-tradicional.module')
      .then(m => m.ResponseTradicionalModule)
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes),
    TranslateModule],
  exports: [RouterModule]
})
export class AppRoutingModule { }
